import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { TradingFloorDetailModel } from "@models/floorStaff/tradingFloorModel"
import { OptionModel } from "@models/global"
import { UseUserInfoTradingFloorModelModel } from "@models/tradingFloor/UserInfoTradingFloorModel"
import http from "@services/httpService"

const getAgencyMasterAuditFieldLabels = (): Record<string, string> => ({
  Name:          L("TRADINGFLOOR_NAME"),
  BusinessOwner: L("TRADINGFLOOR_NAME"),
  Salutation:    L("CUSTOMER_DETAIL_POSITION"),
  Phone:         L("TRADINGFLOOR_PHONE"),
  Email:         L("TRADINGFLOOR_EMAIL"),
  Website:       L("TRADINGFLOOR_WEBSITE"),
  Fax:           L("TRADINGFLOOR_FAX"),
  TaxCode:       L("TRADINGFLOOR_TAX_CODE"),
  Scale:         L("TRADINGFLOOR_SCALE"),
  Group:         L("TRADINGFLOOR_GROUP"),
  Address:       L("CUSTOMER_DETAIL_ADDRESS"),
  CountryId:     L("CUSTOMER_DETAIL_COUNTRY"),
  ProvinceId:    L("CUSTOMER_POTENTIAL_AREA"),
  DistrictId:    L("CUSTOMER_POTENTIAL_AREA"),
  AgencyType:    L("TRADINGFLOOR_AGENCY_TYPE"),
})

class TradingFloorService {
  public async create(body: any) {
    const res = await http.post("api/services/app/AgencyMasters/Create", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async update(body: any) {
    const res = await http.put("api/services/app/AgencyMasters/Update", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/AgencyMasters/Get", {
      params: { id },
    })
    return TradingFloorDetailModel.assign(res.data.result)
  }

  public async activateOrDeactivate(id: number, isActive) {
    const res = await http.post(
      "/api/services/app/AgencyMasters/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async deleteStaffOnCurrentFloor(body: any) {
    const res = await http.post(
      "api/services/app/AgencyMasters/DeleteUser",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async bulkActive(id: number[]) {
    const res = await http.post("api/services/app/Customers/BulkActive", id)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async getAll(params: any) {
    const res = await http.get("api/services/app/AgencyMasters/GetAll", {
      params,
    })
    return res.data.result
  }

  public async getExistPhoneEmail(input: string) {
    const res = await http.get("api/services/app/AgencyMasters/GetExistPhone", {
      params: { input },
    })
    return res.data
  }

  public async getListFloor() {
    const res = await http.get(
      "api/services/app/AgencyMasters/GetListAgencyMaster"
    )
    return res.data.result
  }

  public async getAllCartByAgency(params: any) {
    const res = await http.get("api/services/app/AgencyMasters/GetCard", {
      params,
    })
    return res.data.result
  }

  public async getListEmployee() {
    const res = await http.get("api/services/app/Employees/GetList")
    const result = res.data.result
    return OptionModel.assigns(result || [])
  }

  public async getAllStaffInCurrentTradingFloor(params: any) {
    const res = await http.get(
      "api/services/app/AgencyMasters/GetUserByAgencyId",
      {
        params,
      }
    )
    return res.data.result
  }

  public async getExistPhone(phone: string) {
    const res = await http.get("api/services/app/AgencyMasters/GetExistPhone", {
      params: { phone },
    })
    return UseUserInfoTradingFloorModelModel.assign(res.data.result)
  }

  public async getListAgencyMaster() {
    const res = await http.get(
      "api/services/app/AgencyMasters/GetListAgencyMaster"
    )
    return res.data.result
  }

  public async assignUser(body: any) {
    const result = await http.post(
      "api/services/app/AgencyMasters/AssignUser",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return result.data.result
  }

  public async GetAgencyMasterOutputWithTaxCode(params: any) {
    const res = await http.get("api/services/app/AgencyMasters/GetAgencyMasterOutputWithTaxCode", {
      params,
    })
    return res.data.result
  }

  public async getAuditLog(id: number) {
    const res = await http.get("api/services/app/AgencyMasters/GetAuditLogs", {
      params: { id },
    })
    const labels = getAgencyMasterAuditFieldLabels()
    return (res.data.result || []).map((row: any) => {
      ;(row.items || []).forEach((item: any) => {
        item.propertyName = labels[item.propertyName] ?? item.propertyName
      })
      return row
    })
  }
}

export default new TradingFloorService()
